import * as model from "@/model/report/ReportTemplate";
import { newEntityStoreHelper } from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.ReportTemplate(), newFilter)
    .withStates({
        templateTypeList: [],
        baseModuleUrl: process.env.VUE_APP_REPORT_API_URL + "report-service/report"
    }) //TODO load at the application start
    .withActions({
        getAllTemplateType(context) {
            context.dispatch("api/get", {
                url: context.state.baseModuleUrl + "/reportTemplate/getAllTemplateType"
            },
            { root: true })
            .then(function (data) {
                context.commit("setTemplateTypeList", data);
            })
        },
        addTemplate(context, formData){
            let strCrud = "Save";
            if(formData.get("id") !== null)
                strCrud = "Edit";
            context.dispatch('api/postMultipart',{
              url: context.state.baseModuleUrl + "/reportTemplate/addReportTemplate",
              data: formData
              }, { root: true }).then(function(entityReturn) {
                context.dispatch("base/showSuccess", {
                    userAlertSuccessStr: strCrud + " success {id=" + entityReturn.data.id + "}",
                    dismissCountDown: 5,
                    userAlertSuccessVisible: false,
                }, { root: true }).then(function() {
                    var successLine = "Save" + " Successed"
                    if(context.state.checkedItems.length > 0)
                        successLine = "Edit" + " Successed {id=" + context.state.checkedItems.join(",") + "}"
                    context.dispatch("base/showSuccess", {
                        userAlertSuccessStr: successLine,
                        dismissCountDown: 5,
                        userAlertSuccessVisible: false,
                    }, { root: true }).then(function() {
                        context.dispatch("base/MMFbackToList", "reportTemplate", {root: true}).then(function () {
                            context.dispatch("base/MMFLoadRows", "reportTemplate", {root: true});
                        });
                    })
                }).catch(function(){
                    var warnLine = "Save" + " Failed"
                    if(context.state.checkedItems.length > 0)
                        warnLine = "Edit" + " Failed {id=" + context.state.checkedItems.join(",") + "}"
                    context.dispatch("base/showWarning", {
                        userAlertWarningStr: warnLine,
                        userAlertWarningVisible: true,
                    }, { root: true });
                    return;
                });
            });
        },
        generateReport(context, items){
            if (items) {
                context.dispatch('api/post',{
                url: context.state.baseModuleUrl + "/reportTemplate/generateReport",
                data: {
                    id: items.id,
                    runtimeParam: items.runtimeParam
                }
                }, { root: true }).then(()=>{
                    var successLine = "Report Is Generating"  + " {id=" + context.state.checkedItems.join(",") + "}"
                    context.dispatch("base/showSuccess", {
                        userAlertSuccessStr: successLine,
                        dismissCountDown: 5,
                        userAlertSuccessVisible: false,
                    }, { root: true }).then(function() {
                        
                    })
                }).catch(function(){
                    var warnLine = "Generate Report Failed"  + " Successed {id=" + context.state.checkedItems.join(",") + "}"
                    context.dispatch("base/showWarning", {
                        userAlertWarningStr: warnLine,
                        userAlertWarningVisible: true,
                    }, { root: true });
                    return;
                })
            }
        },
        autoReport(context, items){
            let requestUrl = context.state.baseModuleUrl + "/reportTemplate/autoReport?ids=" + items.join(",")
            context.dispatch("api/get", {
                url: requestUrl,
            },{ root: true }).then(function() {
                context.dispatch("base/showSuccess", {
                    userAlertSuccessStr: "Auto Report" + " Success {id=" + context.state.checkedItems.join(",") + "}",
                    dismissCountDown: 5,
                    userAlertSuccessVisible: false,
                }, { root: true }).then(function() {
                    context.dispatch("base/MMFbackToList", "reportTemplate", {root: true}).then(function () {
                        context.dispatch("base/MMFLoadRows", "reportTemplate", {root: true});
                    });
                })
            }).catch(function(){
                context.dispatch("base/showWarning", {
                    userAlertWarningStr: "Auto Report" + " Failed {id=" + context.state.checkedItems.join(",") + "}",
                    userAlertWarningVisible: true,
                }, { root: true });
                return;
            });
        },
        stopAutoReport(context, items){
            let requestUrl = context.state.baseModuleUrl + "/reportTemplate/stopAutoRepot?ids=" + items.join(",")
            context.dispatch("api/get", {
                url: requestUrl,
            },{ root: true }).then(function() {
                context.dispatch("base/showSuccess", {
                    userAlertSuccessStr: "Manual Report" + " Success {id=" + context.state.checkedItems.join(",") + "}",
                    dismissCountDown: 5,
                    userAlertSuccessVisible: false,
                }, { root: true }).then(function() {
                    context.dispatch("base/MMFbackToList", "reportTemplate", {root: true}).then(function () {
                        context.dispatch("base/MMFLoadRows", "reportTemplate", {root: true});
                    });
                })
            }).catch(function(){
                context.dispatch("base/showWarning", {
                    userAlertWarningStr: "Manual Report" + " Failed {id=" + context.state.checkedItems.join(",") + "}",
                    userAlertWarningVisible: true,
                }, { root: true });
                return;
            });
        },
    })
    .withMutations({
        setTemplateTypeList(state, templateTypeList) {
            state.templateTypeList = templateTypeList;
        },
        setTemplateConfig(state, value) {
            state.entity.templateConfig = value
        },
        setRuntimeParam(state, value) {
            state.entity.runtimeParam = value
        }
    })
    .buildStore()